import React, { useCallback } from 'react';

import { Steps } from '@/modules/transaction/components/Statements/components/ChangeEmailModal/ChangeEmailModal.constants';
import useEditEmailStore from '@/modules/transaction/components/Statements/components/ChangeEmailModal/stores/useEditEmail.store';
import EmailVerificationCodeModal from '@/modules/user/components/Verification/EmailVerificationModal/EmailVerificationCodeModal';
import useUpdateEmployeeQuery from '@/modules/user/queries/useUpdateEmployee.query';
import useEmployeeStore from '@/modules/user/stores/useEmployee.store';

interface Props {
  onClose: () => void;
  setStep: (value: Steps) => void;
}

const EmailVerificationModal: React.FC<Props> = ({ onClose, setStep }) => {
  const { state } = useEditEmailStore();
  const { updateEmployee } = useUpdateEmployeeQuery();
  const { setEmployee } = useEmployeeStore();

  const handleChangePreferredEmail = useCallback(async () => {
    await updateEmployee({ is_employee_email_preferred: state.isEmployeeEmailPreferred });
    setEmployee({ isEmployeeEmailPreferred: state.isEmployeeEmailPreferred });
  }, [updateEmployee, setEmployee, state.isEmployeeEmailPreferred ]);

  const handleBack = useCallback(() => {
    setStep(Steps.EditEmail);
  }, [setStep]);

  const handleNext = useCallback(async () => {
    try {
      await handleChangePreferredEmail();
      setStep(Steps.SuccessfullyChanged);
    } catch {
      setStep(Steps.SuccessfullyChanged);
    }
  }, [setStep, handleChangePreferredEmail]);
  
  return (
    <EmailVerificationCodeModal
      email={state?.employeeProvidedEmail || ''}
      onBack={handleBack}
      onSetVisible={onClose}
      onNext={handleNext}
    />
  );
};

export default EmailVerificationModal;
